import axios from 'axios';

export default {
  getAllColors() {
    return axios.get(`${process.env.VUE_APP_API_URL}/colors?type=Frame`);
  },
};
